import { useEffect, useRef, useState } from 'react';

// https://overreacted.io/making-setinterval-declarative-with-react-hooks/
function useInterval(callback, delay, run = true) {
	const [intervalId, setIntervalId] = useState(null)
	const savedCallback = useRef();

	// Remember the latest callback.
	useEffect(() => {
		savedCallback.current = callback;
	}, [callback]);

	// Set up the interval.
	useEffect(() => {
		function tick() {
			savedCallback.current();
		}

		if (run && delay !== null) {
			const id = setInterval(tick, delay);
			setIntervalId(id)
		} else {
			if (intervalId) {
				clearInterval(intervalId);
			}
		}
		
		return () => {
			if (intervalId) {

				clearInterval(intervalId);
			}
		}
		// eslint-disable-next-line
	}, [run, delay])
}

export default useInterval;